export default __webpack_public_path__ + "static/media/OfficeLocationxl.af76dee6.xlsx";